import { Directive, HostBinding, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[spDnd]'
})
export class DndDirective {
  @Output() fileDropped: EventEmitter<File[]> = new EventEmitter<File[]>();
  @Output() fileDragged: EventEmitter<boolean> = new EventEmitter<boolean>();

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileDragged.emit(true);
    console.log('Drag over');
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
    this.fileDragged.emit(false);
    console.log('Drag leave');
  }

  // Drop listener
  @HostListener('drop', ['$event']) ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    this.fileDragged.emit(false);
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      console.log(`You dropped ${files.length} files`);
      this.fileDropped.emit(files);
    }
  }

  @HostBinding('class.fileover') fileOver: boolean;

  constructor() { }

}
